import Auth from './Auth';
import Loader from './Loader'
// import Profile from './Profile'
// import Admin from './Admin'
const models = {
    auth: Auth,
    // admin:Admin,
    loader: Loader,
    // profile: Profile,
    

}
export default models;